function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0.046875V6.04871H6V0.046875H0Z",
  fill: "#00AAFF"
});
const SvgBlueSquareIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 6,
  height: 7,
  viewBox: "0 0 6 7",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBlueSquareIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/blue-square-icon.9ff78fac.svg";
export { ForwardRef as ReactComponent };